import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { ActivatedRoute, Router } from '@angular/router';
import { MapStateCreator } from './map/state/map-state-creator';
import { Store } from '@ngrx/store';
import { WidgetStateCreator } from './widget/state/widget_state_creator';
import { IntegrateStateCreator } from './integrate/state/integrate_state_creator';
import { NavigationStateCreator } from './shared/navigation/state/navigation_state_creator';
import { ENV } from '../environment';
import { RedirectService } from '../shared/services/redirect.service';
import { ManualSetupStateCreator } from './integrate/main/manual_setup/store/manual_setup_state_creator';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { WindowService } from '../shared/services/window.service';
import { MOBILE_PATH } from './shared/navigation/constants';
import { mobileUpdate } from './mobile/state/mobile-actions-creator';
import { MobileStateCreator } from './mobile/state/mobile-state-creator';
import { FeatureService } from './shared/services/feature.service';
import { mapUpdate } from './map/state/map-actions-creator';
import { widgetUpdate } from './widget/state/widget_actions';
import { navUpdate } from './shared/navigation/state/navigation_actions_creator';
import { integrateUpdate } from './integrate/state/integrate_actions';
import { manualUpdate } from './integrate/main/manual_setup/store/manual_setup_actions';
import { IAppState } from '../app_state';

@Component({
  selector: 'yi-install', // <yi-install></yi-install>
  template: require('./install.component.html'),
  styles: [require('./install.component.scss')],
})
export class InstallComponent implements OnInit {

  isLastStep = false;
  lastStepName = '';
  layoutStyle =  null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<IAppState>,
    private redirectService: RedirectService,
    private mapStateCreator: MapStateCreator,
    private widgetStateCreator: WidgetStateCreator,
    private integrateStateCreator: IntegrateStateCreator,
    private navigationStateCreator: NavigationStateCreator,
    private titleService: Title,
    private manualSetupStateCreator: ManualSetupStateCreator,
    private mobileStateCreator: MobileStateCreator,
    private translateService: TranslateService,
    private windowService: WindowService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private featureService: FeatureService
  ) {
    let allData = Object.assign.apply(Object, this.activatedRoute.snapshot.data.installData);

    if (this.MainFeatureEnabled(allData)) {
      this.initMapState(allData);
      this.initWidgetState(allData);
      this.initIntegrateState(allData);
      this.initNavigationState(allData);
      this.initManualSetupState(allData);
      this.initMobileView(allData);
    } else {
      this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint + '#/login');
    }

    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        let currentStep = items.navigationItems.filter(item => item.active === true)[0];
        if (currentStep) {
          this.isLastStep = currentStep.isLastStep;
          this.lastStepName = (this.translateService.instant(currentStep.name) + '-last-step').toLowerCase();
        }
      }
    );

    this.store.select(state => state.app.install.mobile).subscribe(
      state => {
        let isMobile = state.isMobile;
        this.layoutStyle = isMobile ? { height: '100%' } : null;
        if (isMobile) {
          this.cd.detectChanges();
        }
      }
    );

    if (this.windowService.isMobileWindow()) {
      this.router.navigate([MOBILE_PATH]);
    }

    this.featureService.setFeatureSettings('InstallationV2',
      {
        settings: {
          install_status: 'Started'
        }
      }
    ).subscribe();
  }

  private MainFeatureEnabled(allData: any) {
    return allData['mainFeatureEnabled'];
  }

  private initMapState(allData: any) {
    let mapState = this.mapStateCreator.create(allData);
    if (mapState) {
      this.store.dispatch(mapUpdate({ payload: mapState}));
    }
  }
  private initWidgetState(allData: any) {
    let widgetState = this.widgetStateCreator.create(allData);
    if (widgetState) {
      this.store.dispatch(widgetUpdate({payload: widgetState}));
    }
  }
  private initIntegrateState(allData: any) {
    let integrateState = this.integrateStateCreator.create(allData);
    if (integrateState) {
      this.store.dispatch(integrateUpdate({payload: integrateState}));
    }
  }

  private initNavigationState(allData: any) {
    let navigationState = this.navigationStateCreator.create(allData);
    if (navigationState) {
      this.store.dispatch(navUpdate({payload: navigationState.navigationItems}));
    }
  }

  private initManualSetupState(allData: any) {
    let accordionItems = this.manualSetupStateCreator.create(allData);
    if (accordionItems) {
      this.store.dispatch(manualUpdate({accordionItems: accordionItems}));
    }
  }

  private initMobileView(allData: any) {
    let mobileState = this.mobileStateCreator.create(allData);
    if (mobileState) {
      this.store.dispatch(mobileUpdate({payload: mobileState}));
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Install Yotpo');
  }

}
